import React from "react";
import "../StaffList/StaffList.css";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";

function setId(id) {
  localStorage.setItem('userId', id);
}

const StaffList = ({ userDetailResponse, setSelectedUser, setOpenStaffView, openStaffView }) => {
  return (
    <div className="container-fluid">
      <div className="staffList">
        <table>
          <tr className="staffListHeading">
            <th>S No.</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Status</th>
            <th>Details</th>
          </tr>
          {userDetailResponse !== null ? (
            userDetailResponse.map((user, index) => (
              <tr key={user.customer_id}>
                <td>{++index}</td>
                <td>{user.name}</td>
                
                <td>{user.email}</td>
                <td>{user.mobileNo}</td>
                <td>
                  <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                  </button>
                </td>
                <td>
                  <button
                    style={{ height: "30px", width: "38px" }}
                    onClick={() => {
                      setOpenStaffView(!openStaffView);
                      setId(user.customer_id);
                      setSelectedUser(user);  
                    }}
                  >
                    <SearchIcon className="icon" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <p>empty</p>
          )}
        </table>
      </div>
    </div>
  );
};

export default StaffList;
